import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DialogService } from '../../../dialog/services/dialog.service';
import { ReviewResponseDTO } from '../../model/reviewResponseDTO';
import { TaskService } from '../../services/tasks.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription, tap, from, of, zip } from 'rxjs';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupedReviewRespose } from '../../model/groupedTasks';
import { PagedResultTask } from '../../model/pagedResultTask';
import { TaskDetailDialogComponent } from '../../task-detail-dialog/task-detail-dialog.component';

@Component({
  selector: 'app-open-task-list',
  templateUrl: './open-task-list.component.html',
  styleUrls: ['./open-task-list.component.css']
})
export class OpenTaskListComponent implements OnInit, OnDestroy, AfterViewInit {
  tasks: ReviewResponseDTO[] = [];
  groupedTasks: GroupedReviewRespose[] = [];
  dataSource: ReviewResponseDTO[] = [];
  isListloading = false;
  displayedColumns: string[] = ['id', 'requirementTitle', 'requirementId', 'approvalStatus'];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  paginationSubscription?: Subscription;
  dialogBoxSubscription?: Subscription;
  isError = false;
  errorMessage!: string;
  totalRecords?: number;
  isEmptyList = false;
  constructor(private readonly requestService: TaskService,
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dialogService: DialogService) {
  }
    ngAfterViewInit(): void {
      this.paginationSubscription = this.paginator?.page.pipe(tap(() => this.getOpenTasks())).subscribe();
    }
  ngOnDestroy(): void {
    this.paginationSubscription?.unsubscribe();
    this.dialogBoxSubscription?.unsubscribe();
  }

  getOpenTasks() {
    this.isListloading = true;
    this.isError = false;
    this.requestService.getOpenTasks(
      this.paginator?.pageSize ?? 10,
      this.paginator?.pageIndex ?? 0).subscribe({
        next: (response: PagedResultTask) => {
          this.totalRecords = response.totalRecords;
          this.isEmptyList = this.totalRecords == null ? true : false;
          this.groupedTasks = [];
          from(response.records).pipe(
            groupBy(res => res.requestId),
            mergeMap((group) => zip(of(group.key), group.pipe(toArray())))
          ).subscribe({
            next: (groupedRes) => {            
              this.groupedTasks.push({ key: groupedRes[0], tasks: groupedRes[1] })
             }
          })
        },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
        this.isListloading = false; 
      },
      complete: () => { this.isListloading = false; }
    });
  }

  ngOnInit() {
    this.getOpenTasks();
  }

  onTaskNaviagte(taskId: number) {
    const taskDialogRef = this.dialog.open(TaskDetailDialogComponent, {
      data: { id: taskId },
      width: '100%',
      height: '100%',
      maxWidth:'100vw',
    });
    this.dialogBoxSubscription = taskDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.router.navigate(['/opentasks'], { relativeTo: this.route });
      }
    });
  }

  onrequestnavigate(requestId:number){
    const url = this.router.createUrlTree([`/request/detail/${requestId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }

  onTaskNaviagteNewPage(taskId:number){
    const url = this.router.createUrlTree([`/task/detail/${taskId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }
  
  getCSSColorStatus(approvalStatus: string):string {        
    return this.requestService.getCSSColorforTask(approvalStatus);    
  }
}
